import { useEffect, useRef, useState } from 'react'

import {
  getDataLoaderResponseData,
  getDataLoaderServerError,
  isDataLoaderLatestLoad,
} from './useDataLoader.utils'

export function useDataLoader({
  getData,
  getResponseData = getDataLoaderResponseData,
}) {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)
  const [isLoading, setLoading] = useState(true)

  const loadIdRef = useRef(0)

  function isLatestLoad(loadId) {
    return isDataLoaderLatestLoad({ latestLoadId: loadIdRef.current, loadId })
  }

  async function handleLoad() {
    loadIdRef.current += 1

    const loadId = loadIdRef.current

    return getData()
      .then(response => {
        if (isLatestLoad(loadId)) {
          setData(getResponseData(response))
          setError(null)
        }
      })
      .catch(loadError => {
        if (isLatestLoad(loadId)) {
          setError(loadError)
        }
      })
      .finally(() => {
        if (isLatestLoad(loadId)) {
          setLoading(false)
        }
      })
  }

  async function handleReload() {
    setLoading(true)

    return handleLoad()
  }

  useEffect(() => {
    handleLoad()
  }, [])

  return {
    data,
    error,
    handleReload,
    isLoadFailed: Boolean(error),
    isLoading,
    serverError: getDataLoaderServerError(error),
    setData,
  }
}
